import { defineComponent as _defineComponent } from 'vue'
import { provideFormsConfig } from './composables/useFormsConfig';

interface Props {
  baseUrl?: string;
  recaptcha?: {
    siteKey?: string;
    theme?: 'light' | 'dark';
    size?: 'normal' | 'compact';
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormsProvider',
  props: {
    baseUrl: null,
    recaptcha: null
  },
  setup(__props: any) {

const props = __props as {
  baseUrl?: string;
  recaptcha?: {
    siteKey?: string;
    theme?: 'light' | 'dark';
    size?: 'normal' | 'compact';
  };
};



provideFormsConfig({
  baseUrl: props.baseUrl,
  recaptcha: props.recaptcha,
});

return { __sfc: true,props }
}

})